<template>
  <div class="lg:px-8">
    <div class="max-w-7xl mx-auto w-full">
      <div class="py-10 flex flex-col justify-center gap-5">
        <div class="flex items-center justify-center px-5 lg:px-0">
          <div class="flex-grow border-t-2 border-black"></div>
          <h2
            class="px-4 text-[21px] lg:text-3xl text-[#001c54] font-semibold text-center"
          >
            Programs Offered
          </h2>
          <div class="flex-grow border-t-2 border-black"></div>
        </div>

        <div class="hidden lg:block px-4">
          <div class="w-full">
            <div class="flex gap-3">
              <button
                v-for="tab in tabs"
                :key="tab"
                @click="SelectedTab = tab"
                :class="{
                  ' bg-[#fccf26]': SelectedTab === tab,
                  'bg-[#001c54] text-white': SelectedTab !== tab,
                }"
                class="font-bold text-[18px] p-3 w-full"
              >
                {{ tab }}
              </button>
            </div>
          </div>

          <div v-if="SelectedTab === 'MBA'">
            <div class="mt-3">
              <p
                class="text-left text-sm xl:text-md mt-4 mb-4 leading-[1.8rem]"
              >
                This is a Master's Level program, leading to the grant of a
                degree of Master of Business Administration of JAIN
                (Deemed-to-be University). This two-year program offers
                foundation courses, core courses, specialization courses, and a
                comprehensive master thesis intermediary apart from an option to
                pursue a cross-functional and open elective. The core and
                specialization courses incorporate the AICTE’s model curriculum
                as prescribed for a full-time MBA program. The specialization
                courses have been designed keeping in mind the industry’s
                requirements. The offering of these specialization courses right
                from the 2nd Semester of the program ensures a deep dive into
                the specialization. The program is designed to provide in-depth
                knowledge of the chosen specialization and its applications in
                improving business processes and decision making. The program’s
                curriculum is intended to increase a learner’s business
                knowledge and leadership skills thus providing a way to
                accelerate one’s career for corporate roles in management.
              </p>
              <div class="flex gap-20">
                <div class="w-[40rem]">
                  <img
                    src="@/assets/LPnew/images/programs/mba.jpg"
                    alt=""
                    class="w-[600px]"
                  />
                </div>
                <div>
                  <div class="text-left">
                    <div class="text-3xl font-bold text-[#001c54] pb-2">
                      Online MBA
                    </div>
                    <div
                      class="flex-grow border-t-4 border-yellow-500 pt-2"
                    ></div>

                    <div class="flex gap-2">
                      <div class="font-bold text-black">Duration:</div>
                      <div class="text-[#777777] font-medium">2 Years</div>
                    </div>

                    <p class="text-black pt-2 pb-2">Specializations Offered:</p>
                    <div class="w-[40rem]">
                      <ul
                        class="list-disc ml-4 flex flex-wrap gap-x-20 text-start gap-y-4"
                      >
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Human Resource Management
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Finance
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Marketing
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          General Management
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Systems and Operations Management
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Finance and Marketing
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Human Resource Management and Finance
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Marketing and Human Resource Management
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Project Management
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Information Technology Management
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Healthcare Management
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Logistics & Supply Chain Management
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Business Intelligence & Analytics
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Entrepreneurship and Leadership
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          International Finance (Accredited by ACCA, UK)
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          International Business Management
                        </li>
                        <!-- <li class="w-[17rem] text-[#777777] text-[14px]">
                          Sports Management
                        </li> -->
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Retail Banking Operations
                        </li>
                      </ul>
                    </div>
                    <p class="text-black mt-2 mb-2">Eligibility:</p>
                    <div class="progList width100">
                      <ul class="text-[14px] text-[#7a7a7a] list-disc ml-4">
                        <li>
                          Bachelor's Degree (Minimum of 3 Years Degree Program),
                          with at least 50% marks or equivalent CGPA (45% in
                          case of SC/ST ) from a recognized University.
                        </li>
                        <li class="pt-2">
                          Students who are in the final year of the bachelor’s
                          degree are also eligible to apply.
                        </li>
                      </ul>
                    </div>
                    <div
                      class="mt-4 mb-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
                    >
                      <a href="#applyBox" class="aplybtn">Apply Now </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="SelectedTab === 'MCA'">
            <div class="mt-3">
              <p
                class="text-left text-sm xl:text-md mt-4 mb-4 leading-[1.8rem]"
              >
                This is a Master's Level program, leading to the grant of a
                degree of Master of Business Administration of JAIN
                (Deemed-to-be University). This two-year program offers
                foundation courses, core courses, specialization courses, and a
                comprehensive master thesis intermediary apart from an option to
                pursue a cross-functional and open elective. The core and
                specialization courses incorporate the AICTE’s model curriculum
                as prescribed for a full-time MBA program. The specialization
                courses have been designed keeping in mind the industry’s
                requirements.
              </p>
              <div class="flex gap-20">
                <div class="w-[40rem]">
                  <img
                    src="@/assets/LPnew/images/programs/mca.jpg"
                    alt=""
                    class="w-[600px]"
                  />
                </div>
                <div>
                  <div class="text-left">
                    <div class="text-3xl font-bold text-[#001c54] pb-2">
                      Online MCA
                    </div>
                    <div
                      class="flex-grow border-t-4 border-yellow-500 pt-2"
                    ></div>

                    <div class="flex gap-2">
                      <div class="font-bold text-black">Duration:</div>
                      <div class="text-[#777777] font-medium">2 Years</div>
                    </div>

                    <p class="text-black pt-2 pb-2">Specializations Offered:</p>
                    <div class="w-[40rem]">
                      <ul
                        class="list-disc flex flex-wrap gap-x-12 text-start text-[14px] gap-y-4 ml-4"
                      >
                        <li class="w-[17rem] text-[#777777] text-md">
                          Computer Science & IT
                        </li>
                        <li class="w-[17rem] text-[#777777] text-md">
                          Cyber Security
                        </li>
                        <li class="w-[17rem] text-[#777777] text-md">
                          Data Analytics
                        </li>
                      </ul>
                    </div>
                    <p class="text-black mt-2 mb-2">Eligibility:</p>
                    <div class="progList width100">
                      <ul class="text-[14px] text-[#7a7a7a] list-disc ml-4">
                        <li>
                          Bachelor's Degree (Minimum of 3 Years Degree Program),
                          with at least 50% marks or equivalent CGPA (45% in
                          case of SC/ST ) from a recognized University.
                        </li>
                        <li class="pt-2">
                          The candidate must have passed Mathematics at 10+2
                          level or Graduation level securing 50% marks.
                        </li>
                        <li class="pt-2">
                          Students who are in the final year of the bachelor’s
                          degree are also eligible to apply.
                        </li>
                      </ul>
                    </div>
                    <div
                      class="mt-4 mb-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
                    >
                      <a href="#applyBox" class="aplybtn">Apply Now </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="SelectedTab === 'M.Com'">
            <div class="mt-3">
              <p
                class="text-left text-sm xl:text-md mt-4 mb-4 leading-[1.8rem]"
              >
                The Master of Commerce is a two-year Postgraduate Degree Program
                to prepare you as skilled professionals in the sector of
                accounting and finance. The complexity of business operations
                today demands a blend of accounting and finance expertise. This
                program will provide you with a strong foundation that you will
                need to pursue a career in Finance and Accounting in a corporate
                setup. One of the avenues that open up after completing this
                program is that of teaching or pursuing research initiatives
                through a Ph.D. Along with functional and domain expertise, the
                program will also equip you with the competencies and skills
                required to advance your career into leadership and strategic
                roles. The Research project requires you to carry out in-depth
                research in your area of interest. This will give you an
                opportunity to practice your learnings. You will also be
                encouraged to publish your research with the support of a
                mentor. The program curriculum encompasses courses of global
                professional accreditation bodies like ACCA and CIMA to give you
                that edge required to compete and succeed.
              </p>
              <div class="flex gap-20">
                <div class="w-[40rem]">
                  <img
                    src="@/assets/LPnew/images/programs/mcom.jpg"
                    alt=""
                    class="w-[600px]"
                  />
                </div>
                <div>
                  <div class="text-left">
                    <div class="text-3xl font-bold text-[#001c54] pb-2">
                      Online M.Com
                    </div>
                    <div
                      class="flex-grow border-t-4 border-yellow-500 pt-2"
                    ></div>

                    <div class="flex gap-2">
                      <div class="font-bold text-black">Duration:</div>
                      <div class="text-[#777777] font-medium">2 Years</div>
                    </div>

                    <p class="text-black pt-2 pb-2">Specializations Offered:</p>
                    <div class="w-[40rem]">
                      <ul
                        class="list-disc flex flex-wrap gap-x-12 text-start text-[14px] gap-y-4 ml-4"
                      >
                        <li class="w-[17rem] text-[#777777] text-md">
                          Accounting and Finance
                        </li>
                        <li class="w-[17rem] text-[#777777] text-md">
                          International Finance (Intergated with ACCA, UK)
                        </li>
                      </ul>
                    </div>
                    <p class="text-black mt-2 mb-2">Eligibility:</p>
                    <div class="progList width100">
                      <ul class="text-[14px] text-[#7a7a7a] list-disc ml-4">
                        <li>
                          Bachelor's Degree (Minimum of 3 Years Degree Program),
                          with at least 50% marks or equivalent CGPA (45% in
                          case of SC/ST ) from a recognized University.
                        </li>
                        <li class="pt-2">
                          The candidate must have passed Mathematics at 10+2
                          level or Graduation level securing 50% marks.
                        </li>
                        <li class="pt-2">
                          Students who are in the final year of the bachelor’s
                          degree are also eligible to apply.
                        </li>
                      </ul>
                    </div>
                    <div
                      class="mt-4 mb-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
                    >
                      <a href="#applyBox" class="aplybtn">Apply Now </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="SelectedTab === 'MA'">
            <div class="mt-3">
              <p
                class="text-left text-sm xl:text-md mt-4 mb-4 leading-[1.8rem]"
              >
                The Master of Arts is a two-year Postgraduate Degree Program.
                There are three programs available – English, Journalism, and
                Economics. This program will prepare you for diverse
                opportunities in both corporate and academia. The innovative
                dissertation component will allow you to undertake a project
                under the supervision of an able mentor for a first-hand
                experience to translate your learnings into real-world
                experience. Through the interactive sessions and seminars,
                learners get an opportunity to also hone their soft skills which
                is very much sought by today’s employers. An Arts Program is
                comparatively more mainstream and nurtures a broader set of
                skills in the chosen discipline.
              </p>
              <div class="flex gap-20">
                <div class="w-[40rem]">
                  <img
                    src="@/assets/LPnew/images/programs/ma.jpg"
                    alt=""
                    class="w-[600px]"
                  />
                </div>
                <div>
                  <div class="text-left">
                    <div class="text-3xl font-bold text-[#001c54] pb-2">
                      Online MA
                    </div>
                    <div
                      class="flex-grow border-t-4 border-yellow-500 pt-2"
                    ></div>

                    <div class="flex gap-2">
                      <div class="font-bold text-black">Duration:</div>
                      <div class="text-[#777777] font-medium">2 Years</div>
                    </div>

                    <p class="text-black pt-2 pb-2">Specializations Offered:</p>
                    <div class="w-[40rem]">
                      <ul
                        class="list-disc flex flex-wrap gap-x-12 text-start gap-y-4 ml-4"
                      >
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          English
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Public Policy
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Economics
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Journalism and Mass Communication
                        </li>
                      </ul>
                    </div>
                    <p class="text-black mt-2 mb-2">Eligibility:</p>
                    <div class="progList width100">
                      <ul class="text-[14px] text-[#7a7a7a] list-disc ml-4">
                        <li>
                          Bachelor’s Degree with Journalism/ English (for
                          respective course) as a major subject from a
                          recognized University with a minimum of 50% of total
                          marks obtained (45% for SC/ST) in the cognate/related
                          subjects in the entire Degree course.The candidate
                          must have passed Mathematics at 10+2 level or
                          Graduation level securing 50% marks.
                        </li>
                        <li class="pt-2">
                          Students who are in the final year of the bachelor’s
                          degree are also eligible to apply.
                        </li>
                      </ul>
                    </div>
                    <div
                      class="mt-4 mb-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
                    >
                      <a href="#applyBox" class="aplybtn">Apply Now </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="SelectedTab === 'BBA'">
            <div class="mt-3">
              <p
                class="text-left text-sm xl:text-md mt-4 mb-4 leading-[1.8rem]"
              >
                The Bachelor of Business Administration is a three-year Degree
                Program designed for those wishing to embark on a professional
                career in management. A business management program will prepare
                you for specific needs of a business. The curriculum is designed
                to provide you a broad overview of all essentials of business
                and management and at the same time provide a deep-dive into a
                functional area of specialization – Finance, Marketing, HRM,
                Analytics, International Finance and many more.
              </p>
              <div class="flex gap-20">
                <div class="w-[40rem]">
                  <img
                    src="@/assets/LPnew/images/programs/bba.jpg"
                    alt=""
                    class="w-[600px]"
                  />
                </div>
                <div>
                  <div class="text-left">
                    <div class="text-3xl font-bold text-[#001c54] pb-2">
                      Online BBA
                    </div>
                    <div
                      class="flex-grow border-t-4 border-yellow-500 pt-2"
                    ></div>

                    <div class="flex gap-2">
                      <div class="font-bold text-black">Duration:</div>
                      <div class="text-[#777777] font-medium">3 Years</div>
                    </div>

                    <p class="text-black pt-2 pb-2">Specializations Offered:</p>
                    <div class="w-[40rem]">
                      <ul
                        class="list-disc flex flex-wrap gap-x-12 text-start gap-y-4 ml-4"
                      >
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Human Resource Management
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Finance
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Marketing
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Engineering and Project Management
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Healthcare Management
                        </li>
                      </ul>
                    </div>
                    <p class="text-black mt-2 mb-2">Eligibility:</p>
                    <div class="progList width100">
                      <ul class="text-[14px] text-[#7a7a7a] list-disc ml-4">
                        <li>
                          XII in Science / Commerce / Arts from PUC / ISC / CBSE
                          or equivalent board.
                        </li>
                        <li class="pt-2">
                          Students who are due to appear in the board exams are
                          also eligible to apply.
                        </li>
                      </ul>
                    </div>
                    <div
                      class="mt-4 mb-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
                    >
                      <a href="#applyBox" class="aplybtn">Apply Now </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="SelectedTab === 'B.COM'">
            <div class="mt-3">
              <p
                class="text-left text-sm xl:text-md mt-4 mb-4 leading-[1.8rem]"
              >
                The Bachelor of Commerce is a three-year Degree Program that
                will prepare you for entry-level roles in both accounting and
                finance. This program with a myriad of specializations will
                provide you with a strong foundation that you will need to
                pursue a career in Finance, Accounting, and Management. The
                program curriculum encompasses courses of professional
                accreditation bodies from across the globe like ACCA, CIMA, CPA
                and CMA to give you that edge required to compete and succeed.
              </p>
              <div class="flex gap-20">
                <div class="w-[40rem]">
                  <img
                    src="@/assets/LPnew/images/programs/bcom.jpg"
                    alt=""
                    class="w-[600px]"
                  />
                </div>
                <div>
                  <div class="text-left">
                    <div class="text-3xl font-bold text-[#001c54] pb-2">
                      Online B.Com
                    </div>
                    <div
                      class="flex-grow border-t-4 border-yellow-500 pt-2"
                    ></div>

                    <div class="flex gap-2">
                      <div class="font-bold text-black">Duration:</div>
                      <div class="text-[#777777] font-medium">3 Years</div>
                    </div>

                    <p class="text-black pt-2 pb-2">Specializations Offered:</p>
                    <div class="w-[40rem]">
                      <ul
                        class="list-disc flex flex-wrap gap-x-12 text-start gap-y-4 ml-4"
                      >
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Accounting & Finance
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          Corporate Accounting
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          International Finance & Accounting (Accredited by
                          ACCA, UK)
                        </li>
                        <li class="w-[17rem] text-[#777777] text-[14px]">
                          International Finance (Accredited by ACCA, UK)
                        </li>
                      </ul>
                    </div>
                    <p class="text-black mt-2 mb-2">Eligibility:</p>
                    <div class="progList width100">
                      <ul class="text-[14px] text-[#7a7a7a] list-disc ml-4">
                        <li>
                          XII in Science / Commerce / Arts from PUC / ISC / CBSE
                          or equivalent board.
                        </li>
                        <li class="pt-2">
                          Students who are due to appear in the board exams are
                          also eligible to apply.
                        </li>
                      </ul>
                    </div>
                    <div
                      class="mt-4 mb-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
                    >
                      <a href="#applyBox" class="aplybtn">Apply Now </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lg:hidden p-2">
          <div class="border-2 border-black">
            <div
              @click="updateFunction('MBA')"
              class="flex justify-between items-center px-1"
            >
              <div
                class="text-start font-bold text-2xl pl-2 py-2 cursor-pointer"
              >
                MBA
              </div>
              <div class="w-[1.5rem]">
                <img
                  src="@/assets/LPnew/images/down-arrow.png"
                  alt="down arrow"
                />
              </div>
            </div>
          </div>
          <div v-show="selctedTabMob == 'MBA'">
            <div class="text-start text-base pt-4 px-2">
              This is a Master's Level program, leading to the grant of a degree
              of Master of Business Administration of JAIN (Deemed-to-be
              University). This two-year program offers foundation courses, core
              courses, specialization courses, and a comprehensive master thesis
              intermediary apart from an option to pursue a cross-functional and
              open elective. The core and specialization courses incorporate the
              AICTE’s model curriculum as prescribed for a full-time MBA
              program. The specialization courses have been designed keeping in
              mind the industry’s requirements. The offering of these
              specialization courses right from the 2nd Semester of the program
              ensures a deep dive into the specialization. The program is
              designed to provide in-depth knowledge of the chosen
              specialization and its applications in improving business
              processes and decision making. The program’s curriculum is
              intended to increase a learner’s business knowledge and leadership
              skills thus providing a way to accelerate one’s career for
              corporate roles in management.
            </div>
            <div class="mx-auto py-2">
              <img
                src="@/assets/LPnew/images/programs/mba.jpg"
                alt="mba"
                class="w-full"
              />
            </div>
            <div>
              <div
                class="text-3xl font-bold text-[#001c54] pb-2 text-start pt-4"
              >
                Online MBA
              </div>
              <div
                class="flex-grow border-t-4 border-yellow-500 pt-2 px-4"
              ></div>
              <div class="flex gap-2">
                <div class="font-bold text-black">Duration:</div>
                <div class="text-[#777777] font-medium">2 Years</div>
              </div>
              <p class="text-black pt-2 pb-2 text-start">
                Specializations Offered:
              </p>
              <div>
                <ul
                  class="list-disc flex flex-wrap gap-x-12 text-start gap-y-4 pl-6"
                >
                  <li class="w-[15rem] text-[#777777] text-base">
                    Human Resource Management
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">Finance</li>
                  <li class="w-[15rem] text-[#777777] text-base">Marketing</li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    General Management
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Systems and Operations Management
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Finance and Marketing
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Human Resource Management and Finance
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Marketing and Human Resource Management
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Project Management
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Information Technology Management
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Healthcare Management
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Logistics & Supply Chain Management
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Business Intelligence & Analytics
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Entrepreneurship and Leadership
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    International Finance (Accredited by ACCA, UK)
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    International Business Management
                  </li>
                  <!-- <li class="w-[15rem] text-[#777777] text-base">
                    Sports Management
                  </li> -->
                  <li class="w-[15rem] text-[#777777] text-base">
                    Retail Banking Operations
                  </li>
                </ul>
              </div>
              <p class="text-black mt-2 mb-2 text-start pl-2">Eligibility:</p>
              <div class="">
                <ul class="text-sm text-[#7a7a7a] list-disc text-start pl-6">
                  <li>
                    Bachelor's Degree (Minimum of 3 Years Degree Program), with
                    at least 50% marks or equivalent CGPA (45% in case of SC/ST
                    ) from a recognized University.
                  </li>
                  <li class="pt-2">
                    Students who are in the final year of the bachelor’s degree
                    are also eligible to apply.
                  </li>
                </ul>
              </div>
              <div
                class="mt-4 mb-4 ml-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
              >
                <a href="#applyBox" class="aplybtn">Apply Now </a>
              </div>
            </div>
          </div>
          <div class="border-2 border-black">
            <div
              @click="updateFunction('MCA')"
              class="flex justify-between items-center px-1"
            >
              <div
                class="text-start font-bold text-2xl pl-2 py-2 cursor-pointer"
              >
                MCA
              </div>
              <div class="w-[1.5rem]">
                <img
                  src="@/assets/LPnew/images/down-arrow.png"
                  alt="down arrow"
                />
              </div>
            </div>
          </div>
          <div v-show="selctedTabMob == 'MCA'">
            <div class="text-start text-base pt-4 px-2">
              This is a Master's Level program, leading to the grant of a degree
              of Master of Business Administration of JAIN (Deemed-to-be
              University). This two-year program offers foundation courses, core
              courses, specialization courses, and a comprehensive master thesis
              intermediary apart from an option to pursue a cross-functional and
              open elective. The core and specialization courses incorporate the
              AICTE’s model curriculum as prescribed for a full-time MBA
              program. The specialization courses have been designed keeping in
              mind the industry’s requirements.
            </div>
            <div class="mx-auto py-2">
              <img src="@/assets/LPnew/images/programs/mca.jpg" alt="mca" />
            </div>
            <div>
              <div
                class="text-3xl font-bold text-[#001c54] pb-2 text-start pt-4"
              >
                Online MCA
              </div>
              <div
                class="flex-grow border-t-4 border-yellow-500 pt-2 px-4"
              ></div>
              <div class="flex gap-2">
                <div class="font-bold text-black">Duration:</div>
                <div class="text-[#777777] font-medium">2 Years</div>
              </div>
              <p class="text-black pt-2 pb-2 text-start">
                Specializations Offered:
              </p>
              <div>
                <ul
                  class="list-disc flex flex-wrap gap-x-12 text-start gap-y-4 pl-6"
                >
                  <li class="w-[15rem] text-[#777777] text-base">
                    Computer Science & IT
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Cyber Security
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Data Analytics
                  </li>
                </ul>
              </div>
              <p class="text-black mt-2 mb-2 text-start pl-2">Eligibility:</p>
              <div class="">
                <ul class="text-sm text-[#7a7a7a] list-disc text-start pl-6">
                  <li>
                    Bachelor's Degree (Minimum of 3 Years Degree Program), with
                    at least 50% marks or equivalent CGPA (45% in case of SC/ST
                    ) from a recognized University.
                  </li>
                  <li class="pt-2">
                    The candidate must have passed Mathematics at 10+2 level or
                    Graduation level securing 50% marks.
                  </li>
                  <li class="pt-2">
                    Students who are in the final year of the bachelor’s degree
                    are also eligible to apply.
                  </li>
                </ul>
              </div>
              <div
                class="mt-4 mb-4 ml-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
              >
                <a href="#applyBox" class="aplybtn">Apply Now </a>
              </div>
            </div>
          </div>

          <div class="border-2 border-black">
            <div
              @click="updateFunction('M.COM')"
              class="flex justify-between items-center px-1"
            >
              <div
                class="text-start font-bold text-2xl pl-2 py-2 cursor-pointer"
              >
                M.COM
              </div>
              <div class="w-[1.5rem]">
                <img
                  src="@/assets/LPnew/images/down-arrow.png"
                  alt="down arrow"
                />
              </div>
            </div>
          </div>
          <div v-show="selctedTabMob == 'M.COM'">
            <div class="text-start text-base pt-4 px-2">
              The Master of Commerce is a two-year Postgraduate Degree Program
              to prepare you as skilled professionals in the sector of
              accounting and finance. The complexity of business operations
              today demands a blend of accounting and finance expertise. This
              program will provide you with a strong foundation that you will
              need to pursue a career in Finance and Accounting in a corporate
              setup. One of the avenues that open up after completing this
              program is that of teaching or pursuing research initiatives
              through a Ph.D. Along with functional and domain expertise, the
              program will also equip you with the competencies and skills
              required to advance your career into leadership and strategic
              roles. The Research project requires you to carry out in-depth
              research in your area of interest. This will give you an
              opportunity to practice your learnings. You will also be
              encouraged to publish your research with the support of a mentor.
              The program curriculum encompasses courses of global professional
              accreditation bodies like ACCA and CIMA to give you that edge
              required to compete and succeed.
            </div>
            <div class="mx-auto py-2">
              <img src="@/assets/LPnew/images/programs/mcom.jpg" alt="mcom" />
            </div>
            <div>
              <div
                class="text-3xl font-bold text-[#001c54] pb-2 text-start pt-4"
              >
                Online M.COM
              </div>
              <div
                class="flex-grow border-t-4 border-yellow-500 pt-2 px-4"
              ></div>
              <div class="flex gap-2">
                <div class="font-bold text-black">Duration:</div>
                <div class="text-[#777777] font-medium">2 Years</div>
              </div>
              <p class="text-black pt-2 pb-2 text-start">
                Specializations Offered:
              </p>
              <div>
                <ul
                  class="list-disc flex flex-wrap gap-x-12 text-start gap-y-4 pl-6"
                >
                  <li class="w-[15rem] text-[#777777] text-base">
                    Accounting and Finance
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    International Finance (Intergated with ACCA, UK)
                  </li>
                </ul>
              </div>
              <p class="text-black mt-2 mb-2 text-start pl-2">Eligibility:</p>
              <div class="">
                <ul class="text-sm text-[#7a7a7a] list-disc text-start pl-6">
                  <li>
                    Bachelor's Degree (Minimum of 3 Years Degree Program), with
                    at least 50% marks or equivalent CGPA (45% in case of SC/ST
                    ) from a recognized University.
                  </li>
                  <li class="pt-2">
                    The candidate must have passed Mathematics at 10+2 level or
                    Graduation level securing 50% marks.
                  </li>
                  <li class="pt-2">
                    Students who are in the final year of the bachelor’s degree
                    are also eligible to apply.
                  </li>
                </ul>
              </div>
              <div
                class="mt-4 mb-4 ml-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
              >
                <a href="#applyBox" class="aplybtn">Apply Now </a>
              </div>
            </div>
          </div>

          <div class="border-2 border-black">
            <div
              @click="updateFunction('MA')"
              class="flex justify-between items-center px-1"
            >
              <div
                class="text-start font-bold text-2xl pl-2 py-2 cursor-pointer"
              >
                MA
              </div>
              <div class="w-[1.5rem]">
                <img
                  src="@/assets/LPnew/images/down-arrow.png"
                  alt="down arrow"
                />
              </div>
            </div>
          </div>
          <div v-show="selctedTabMob == 'MA'">
            <div class="text-start text-base pt-4 px-2">
              The Master of Arts is a two-year Postgraduate Degree Program.
              There are three programs available – English, Journalism, and
              Economics. This program will prepare you for diverse opportunities
              in both corporate and academia. The innovative dissertation
              component will allow you to undertake a project under the
              supervision of an able mentor for a first-hand experience to
              translate your learnings into real-world experience. Through the
              interactive sessions and seminars, learners get an opportunity to
              also hone their soft skills which is very much sought by today’s
              employers. An Arts Program is comparatively more mainstream and
              nurtures a broader set of skills in the chosen discipline.
            </div>
            <div class="mx-auto py-2">
              <img src="@/assets/LPnew/images/programs/ma.jpg" alt="mcom" />
            </div>
            <div>
              <div
                class="text-3xl font-bold text-[#001c54] pb-2 text-start pt-4"
              >
                Online MA
              </div>
              <div
                class="flex-grow border-t-4 border-yellow-500 pt-2 px-4"
              ></div>
              <div class="flex gap-2">
                <div class="font-bold text-black">Duration:</div>
                <div class="text-[#777777] font-medium">2 Years</div>
              </div>
              <p class="text-black pt-2 pb-2 text-start">
                Specializations Offered:
              </p>
              <div>
                <ul
                  class="list-disc flex flex-wrap gap-x-12 text-start gap-y-4 pl-6"
                >
                  <li class="w-[15rem] text-[#777777] text-base">English</li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Public Policy
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">Economics</li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Journalism and Mass Communication
                  </li>
                </ul>
              </div>
              <p class="text-black mt-2 mb-2 text-start pl-2">Eligibility:</p>
              <div class="">
                <ul class="text-sm text-[#7a7a7a] list-disc text-start pl-6">
                  <li>
                    Bachelor’s Degree with Journalism/ English (for respective
                    course) as a major subject from a recognized University with
                    a minimum of 50% of total marks obtained (45% for SC/ST) in
                    the cognate/related subjects in the entire Degree course.The
                    candidate must have passed Mathematics at 10+2 level or
                    Graduation level securing 50% marks.
                  </li>
                  <li class="pt-2">
                    Students who are in the final year of the bachelor’s degree
                    are also eligible to apply.
                  </li>
                </ul>
              </div>
              <div
                class="mt-4 mb-4 ml-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
              >
                <a href="#applyBox" class="aplybtn">Apply Now </a>
              </div>
            </div>
          </div>

          <div class="border-2 border-black">
            <div
              @click="updateFunction('BBA')"
              class="flex justify-between items-center px-1"
            >
              <div
                class="text-start font-bold text-2xl pl-2 py-2 cursor-pointer"
              >
                BBA
              </div>
              <div class="w-[1.5rem]">
                <img
                  src="@/assets/LPnew/images/down-arrow.png"
                  alt="down arrow"
                />
              </div>
            </div>
          </div>
          <div v-show="selctedTabMob == 'BBA'">
            <div class="text-start text-base pt-4 px-2">
              The Bachelor of Business Administration is a three-year Degree
              Program designed for those wishing to embark on a professional
              career in management. A business management program will prepare
              you for specific needs of a business. The curriculum is designed
              to provide you a broad overview of all essentials of business and
              management and at the same time provide a deep-dive into a
              functional area of specialization – Finance, Marketing, HRM,
              Analytics, International Finance and many more.
            </div>
            <div class="mx-auto py-2">
              <img src="@/assets/LPnew/images/programs/bba.jpg" alt="bba" />
            </div>
            <div>
              <div
                class="text-3xl font-bold text-[#001c54] pb-2 text-start pt-4"
              >
                Online BBA
              </div>
              <div
                class="flex-grow border-t-4 border-yellow-500 pt-2 px-4"
              ></div>
              <div class="flex gap-2">
                <div class="font-bold text-black">Duration:</div>
                <div class="text-[#777777] font-medium">3 Years</div>
              </div>
              <p class="text-black pt-2 pb-2 text-start">
                Specializations Offered:
              </p>
              <div>
                <ul
                  class="list-disc flex flex-wrap gap-x-12 text-start gap-y-4 pl-6"
                >
                  <li class="w-[15rem] text-[#777777] text-base">
                    Human Resource Management
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">Finance</li>
                  <li class="w-[15rem] text-[#777777] text-base">Marketing</li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Engineering and Project Management
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Healthcare Management
                  </li>
                </ul>
              </div>
              <p class="text-black mt-2 mb-2 text-start pl-2">Eligibility:</p>
              <div class="">
                <ul class="text-sm text-[#7a7a7a] list-disc text-start pl-6">
                  <li>
                    XII in Science / Commerce / Arts from PUC / ISC / CBSE or
                    equivalent board.
                  </li>
                  <li class="pt-2">
                    Students who are due to appear in the board exams are also
                    eligible to apply.
                  </li>
                </ul>
              </div>
              <div
                class="mt-4 mb-4 ml-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
              >
                <a href="#applyBox" class="aplybtn">Apply Now </a>
              </div>
            </div>
          </div>

          <div class="border-2 border-black">
            <div
              @click="updateFunction('B.COM')"
              class="flex justify-between items-center px-1"
            >
              <div
                class="text-start font-bold text-2xl pl-2 py-2 cursor-pointer"
              >
                B.COM
              </div>
              <div class="w-[1.5rem]">
                <img
                  src="@/assets/LPnew/images/down-arrow.png"
                  alt="down arrow"
                />
              </div>
            </div>
          </div>
          <div v-show="selctedTabMob == 'B.COM'">
            <div class="text-start text-base pt-4 px-2">
              The Bachelor of Commerce is a three-year Degree Program that will
              prepare you for entry-level roles in both accounting and finance.
              This program with a myriad of specializations will provide you
              with a strong foundation that you will need to pursue a career in
              Finance, Accounting, and Management. The program curriculum
              encompasses courses of professional accreditation bodies from
              across the globe like ACCA, CIMA, CPA and CMA to give you that
              edge required to compete and succeed.
            </div>
            <div class="mx-auto py-2">
              <img src="@/assets/LPnew/images/programs/bcom.jpg" alt="bcom" />
            </div>
            <div>
              <div
                class="text-3xl font-bold text-[#001c54] pb-2 text-start pt-4"
              >
                Online B.COM
              </div>
              <div
                class="flex-grow border-t-4 border-yellow-500 pt-2 px-4"
              ></div>
              <div class="flex gap-2">
                <div class="font-bold text-black">Duration:</div>
                <div class="text-[#777777] font-medium">3 Years</div>
              </div>
              <p class="text-black pt-2 pb-2 text-start">
                Specializations Offered:
              </p>
              <div>
                <ul
                  class="list-disc flex flex-wrap gap-x-12 text-start gap-y-4 pl-6"
                >
                  <li class="w-[15rem] text-[#777777] text-base">
                    Accounting & Finance
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    Corporate Accounting
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    International Finance & Accounting (Accredited by ACCA, UK)
                  </li>
                  <li class="w-[15rem] text-[#777777] text-base">
                    International Finance (Accredited by ACCA, UK)
                  </li>
                </ul>
              </div>
              <p class="text-black mt-2 mb-2 text-start pl-2">Eligibility:</p>
              <div class="">
                <ul class="text-sm text-[#7a7a7a] list-disc text-start pl-6">
                  <li>
                    XII in Science / Commerce / Arts from PUC / ISC / CBSE or
                    equivalent board.
                  </li>
                  <li class="pt-2">
                    Students who are due to appear in the board exams are also
                    eligible to apply.
                  </li>
                </ul>
              </div>
              <div
                class="mt-4 mb-4 ml-4 bg-[#001c54] w-max px-2 py-1 text-white cursor-pointer"
              >
                <a href="#applyBox" class="aplybtn">Apply Now </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgramsView",
  data() {
    return {
      tabs: ["MBA", "MCA", "M.Com", "MA", "BBA", "B.COM"],
      SelectedTab: "MBA",
      selctedTabMob: "",
    };
  },
  methods: {
    updateFunction(data) {
      if (this.selctedTabMob == "") {
        this.selctedTabMob = data;
      } else {
        this.selctedTabMob = "";
      }
    },
  },
};
</script>

<style></style>
